var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullScreenLoading"},[_c('div',{staticClass:"fullScreenLoading_image"},[_c('img',{staticClass:"loadingImage",attrs:{"src":require("../assets/imagem/loading-2.svg"),"alt":""}}),_c('p',{staticClass:"fullScreenLoading_info"},[_vm._v(" "+_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }